<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="47em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <HangarUsagesDataForm
        ref="hangarUsagesDataForm"
        v-model="hangarUsagesDataForm"
        label-width="10em"
        formMode="search"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import HangarUsagesDataForm from '@/components/organisms/dialog/data/HangarUsagesDataForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    HangarUsagesDataForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      hangarUsagesDataForm: {
        billing_ym: this.getDefaultBillingYm(),
        action_type: undefined,
        operator_code: undefined,
        registration_symbol: undefined,
        hangar_usage_action_time_from: undefined,
        hangar_usage_action_time_to: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.hangarUsagesDataForm.clearFields()
    },
    clickSearch () {
      this.$refs.hangarUsagesDataForm.validate()
        .then((valid) => {
          sessionStorage.setItem('hangarUsagesDataSearchCond', JSON.stringify(this.hangarUsagesDataForm))
          this.dialogVisible = false
          this.$emit('search', this.hangarUsagesDataForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('hangarUsagesDataSearchCond'))
      this.$nextTick(() => {
        this.$refs.hangarUsagesDataForm.clearFields()
        if (searchCond) {
          Object.keys(this.hangarUsagesDataForm).forEach((x) => {
            this.$set(this.hangarUsagesDataForm, x, searchCond[x])
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-search-dialog {
  ::v-deep .el-form-item {
    &.remarks {
      display: none;
    }
  }
}
</style>
